import { Injectable } from '@angular/core';
import { map, Observable, of, tap } from 'rxjs';
import { ExcelPreferencesClient } from './excel-preferences-client.service';

export declare type ExcelPreferences = {
  context: string;
  columns: string[];
};

@Injectable({
  providedIn: 'root',
})
export class UserExcelPreferencesService {
  constructor(private _client: ExcelPreferencesClient) {}
  private readonly _listCache: Map<string, { columns: string[] }> = new Map();

  getPreferences(context: string): Observable<ExcelPreferences> {
    if (this._listCache.has(context)) {
      const pref = this._listCache.get(context);
      return of({ context: context, columns: pref.columns });
    }
    return this._client.get(context).pipe(
      map(res => {
        if (res) {
          this._listCache.set(context, { columns: res.columns });
          return { context: res.context, columns: res.columns };
        }
        return { context: context, columns: [] };
      })
    );
  }

  savePreferences(preferences: ExcelPreferences): Observable<void> {
    if (this._listCache.has(preferences.context)) {
      return this._client.update(preferences).pipe(
        tap(() => {
          const pref = this._listCache.get(preferences.context);
          pref.columns = preferences.columns;
        })
      );
    } else {
      return this._client.create(preferences).pipe(
        tap(() => {
          this._listCache.set(preferences.context, { columns: preferences.columns });
        })
      );
    }
  }
}
